export type PageMetadata = { title?: string; description?: string };

export const pageMetadata: Record<string, PageMetadata> = {
  "/": {
    "description": "SEO agency for law firms: personal injury, DUI, family, criminal defense and estate planning. Ethical legal SEO that wins real cases, from $200/mo."
  },
  "/services": {
    "title": "Legal Marketing Services for Law Firms | PageOne Lawyers",
    "description": "SEO, AI search, PPC, web design and content for law firms, run as one program and measured by signed cases. Plans from $200/month."
  },
  "/services/law-firm-seo": {
    "description": "Law firm SEO services for lawyers and attorneys. Legal SEO that brings in signed cases, from $200/month, with call, lead and case reporting."
  },
  "/services/ai-seo-geo": {
    "description": "AI SEO and GEO for law firms: get your firm cited in ChatGPT, Perplexity and Google AI Overviews. Included in every SEO plan from $200/month."
  },
  "/services/local-seo-for-law-firms": {
    "title": "Local SEO Services for Law Firms & Lawyers | PageOne",
    "description": "Local SEO for law firms that puts you in Google's map pack for the cases you want. Pricing from $200/month, with reporting on calls and cases."
  },
  "/services/ppc-for-law-firms": {
    "title": "Law Firm PPC Management & Attorney PPC Agency | PageOne"
  },
  "/services/link-building-for-law-firms": {
    "title": "Attorney Link Building Services for Law Firms | PageOne"
  },
  "/services/law-firm-website-development": {
    "description": "Law firm website design and development: under 2-second mobile load times, WCAG 2.2 AA accessible, live in 2 to 4 weeks. You own everything."
  },
  "/services/legal-content-writing": {
    "description": "Legal content writing for law firms by experienced legal writers: practice pages, blogs and web copy your attorney approves, in 1 to 2 weeks."
  },
  "/services/social-media-marketing-for-law-firms": {
    "description": "Social media marketing for law firms: content, short-form video and ads on Facebook, Instagram, LinkedIn and TikTok, all reviewed for bar rules."
  },
  "/best-law-firm-seo-companies": {
    "title": "Best Law Firm SEO Companies (2026): How to Choose",
    "description": "What separates the best law firm SEO companies: pricing, deliverables, legal expertise and transparency, plus 7 questions to ask before you hire."
  },
  "/practice-areas": {
    "title": "SEO by Practice Area: Personal Injury, DUI, Family & More",
    "description": "Specialist SEO for every legal practice area: personal injury, DUI, family, criminal defense, estate planning, immigration, bankruptcy and more."
  },
  "/blog": {
    "description": "Practical guides for attorneys on law firm SEO strategy, local SEO, technical SEO, AI search, content and link building from a legal-only agency."
  },
  "/contact": {
    "description": "Book a free strategy call with a senior SEO strategist who understands law firm economics and get a clear plan for more calls and signed cases."
  },
  "/guides": {
    "description": "Free PDF guides on law firm SEO, local SEO, GBP, DUI and personal injury SEO and link building, by Aditya Chauhan."
  },
  "/case-studies/personal-injury-houston": {
    "description": "How a 9-attorney Houston personal injury firm tripled organic consultations in under a year: the strategy, the timeline and the verified results."
  },
  "/blog/law-firm-seo-strategy": {
    "title": "Law Firm SEO Strategy: A 12-Month Plan for 2026"
  },
  "/blog/law-firm-seo-tips": {
    "title": "25 Law Firm SEO Tips for 2026 (Quick Wins to Advanced)"
  },
  "/blog/why-does-seo-for-personal-injury-lawyers-matter": {
    "title": "Why SEO Matters for Personal Injury Lawyers in 2026",
    "description": "Why SEO matters for personal injury and mass tort firms: how clients search after an accident, what a top ranking is worth and where to start."
  },
  "/blog/dui-lawyer-seo-guide": {
    "title": "How DUI Defense Firms Win Local Search: SEO Playbook",
    "description": "A playbook for DUI and DWI defense firms: local pack tactics, county-specific content and after-hours intake that turn arrest searches into calls."
  },
  "/blog/best-law-firm-seo-tools": {
    "title": "Best Law Firm SEO Tools & Software (2026, Tested)",
    "description": "The SEO tools and software we use on live law firm campaigns: keyword research, rank tracking, audits, content briefs and AI visibility, with pricing."
  },
  "/blog/how-law-firms-turn-seo-traffic-into-new-clients": {
    "description": "Law firms turn search traffic into consultations by matching intent with the right page, building trust and making the next step clear. Here is how."
  },
  "/blog/how-to-choose-law-firm-seo-agency": {
    "description": "How to evaluate and hire a legal SEO agency in 2026: the exact 12 questions we would ask if we were shopping for SEO for our own law firm."
  },
  "/blog/keyword-research-for-law-firms": {
    "description": "Step-by-step keyword research for law firms: build keyword maps around case value, not search volume, using case-value tiers and modifiers."
  },
  "/blog/top-geo-agencies-for-law-firms": {
    "description": "Compare the top GEO agencies for law firms in 2026 by pricing, practice-area fit and proof. A buyer's guide to AI search optimization for law firms."
  },
  "/practice-areas/bankruptcy-lawyer-seo": {
    "title": "Bankruptcy Lawyer SEO Services | PageOne Lawyers",
    "description": "SEO for bankruptcy law firms: rank for Chapter 7, Chapter 13, debt relief and small-business bankruptcy searches from people ready to act now."
  },
  "/practice-areas/corporate-business-lawyer-seo": {
    "title": "Corporate & Business Lawyer SEO Services | PageOne",
    "description": "SEO for business and corporate law firms: authority content that puts you in front of founders, CFOs and GCs weighing high-value legal work."
  },
  "/practice-areas/criminal-defense-lawyer-seo": {
    "title": "Criminal Defense Lawyer SEO & Marketing | PageOne",
    "description": "SEO and digital marketing for criminal defense lawyers: rank for every charge you defend, win the map pack and get more signed cases."
  },
  "/practice-areas/dui-dwi-lawyer-seo": {
    "title": "DUI / DWI Lawyer SEO Services | PageOne Lawyers",
    "description": "DUI clients search at the worst moment and hire fast. Our DUI defense SEO wins the map pack and \"arrested last night\" searches in your county."
  },
  "/practice-areas/employment-law-lawyer-seo": {
    "title": "Employment Lawyer SEO Services | PageOne Lawyers",
    "description": "Employment law SEO for plaintiff-side and defense-side firms, with separate content strategies for employees and employers that bring in cases."
  },
  "/practice-areas/estate-planning-lawyer-seo": {
    "title": "Estate Planning Lawyer SEO & Marketing | PageOne",
    "description": "Estate planning SEO company for estate, probate and elder law firms. Rank for wills, trusts and probate searches and book more consultations."
  },
  "/practice-areas/family-law-lawyer-seo": {
    "title": "Family Law & Divorce Lawyer SEO Services | PageOne",
    "description": "Family law SEO for divorce and custody firms: the content, authority and local presence that earn the call after weeks of client research."
  },
  "/practice-areas/immigration-lawyer-seo": {
    "title": "Immigration Lawyer SEO Services | PageOne Lawyers",
    "description": "Immigration lawyer SEO for a multilingual, high-volume practice: rank for visa categories, country-of-origin searches and bilingual queries."
  },
  "/practice-areas/medical-malpractice-lawyer-seo": {
    "title": "Medical Malpractice Lawyer SEO Services | PageOne",
    "description": "Medical malpractice is a small-volume, massive-value vertical. We rank firms for birth injury, surgical error, misdiagnosis, and nursing home neglect."
  },
  "/practice-areas/personal-injury-lawyer-seo": {
    "title": "Personal Injury Lawyer SEO Services | PageOne Lawyers",
    "description": "SEO for personal injury law firms: rank for car accident, truck, motorcycle, slip and fall and wrongful death searches. Ethical and case-driven."
  },
  "/practice-areas/real-estate-law-lawyer-seo": {
    "title": "Real Estate Lawyer SEO Services | PageOne Lawyers",
    "description": "Real estate law SEO is part B2C (buyers, sellers, landlords, tenants) and part B2B (agents, brokers, lenders, investors). We build content for both."
  },
  "/practice-areas/tax-law-lawyer-seo": {
    "title": "Tax Lawyer SEO Services | PageOne Lawyers",
    "description": "Tax law SEO for firms whose clients are scared, sophisticated or both: rank for IRS audit defense, tax debt relief, offshore disclosure and more."
  },
  "/practice-areas/workers-compensation-lawyer-seo": {
    "title": "Workers' Compensation Lawyer SEO Services | PageOne",
    "description": "Workers' comp SEO for a local, intent-driven practice: we get your firm into the local pack, where injured workers choose their lawyer."
  },
  "/glossary": {
    "title": "Law Firm SEO Glossary: 37 Terms Explained | PageOne",
    "description": "Plain-English definitions of the SEO, local search, AI search, PPC and bar-compliance terms every law firm partner should know."
  },
  "/glossary/geo": {
    "title": "What Is GEO? Generative Engine Optimization Explained"
  },
  "/glossary/ymyl": {
    "title": "What Is YMYL? | Law Firm SEO Glossary"
  },
  "/glossary/google-business-profile": {
    "title": "What Is a Google Business Profile? | Law Firm SEO Glossary"
  },
  "/glossary/attorney-advertising-disclaimer": {
    "title": "Attorney Advertising Disclaimer | Law Firm SEO Glossary"
  },
  "/lawyer-seo/arizona-seo": {
    "title": "Lawyer SEO Arizona | Law Firm SEO Company",
    "description": "Lawyer SEO in Arizona: rank in the local pack, win higher-value cases and outgrow competing Arizona law firms."
  },
  "/lawyer-seo/arkansas-seo": {
    "title": "Lawyer SEO Arkansas | Law Firm SEO Company",
    "description": "Lawyer SEO in Arkansas: rank in the local pack, win higher-value cases and outgrow competing Arkansas law firms."
  },
  "/lawyer-seo/atlanta-seo": {
    "title": "Lawyer SEO Atlanta | Law Firm SEO Company",
    "description": "Lawyer SEO in Atlanta: rank in the local pack, win higher-value cases and outgrow competing Atlanta law firms."
  },
  "/lawyer-seo/austin-seo": {
    "title": "Lawyer SEO Austin | Law Firm SEO Company",
    "description": "Lawyer SEO in Austin: rank in the local pack, win higher-value cases and outgrow competing Austin law firms."
  },
  "/lawyer-seo/boston-seo": {
    "title": "Lawyer SEO Boston | Law Firm SEO Company",
    "description": "Lawyer SEO in Boston: rank in the local pack, win higher-value cases and outgrow competing Boston law firms."
  },
  "/lawyer-seo/chicago-seo": {
    "title": "Lawyer SEO Chicago | Law Firm SEO Company",
    "description": "Lawyer SEO in Chicago: rank in the local pack, win higher-value cases and outgrow competing Chicago law firms."
  },
  "/lawyer-seo/cleveland-seo": {
    "title": "Lawyer SEO Cleveland | Law Firm SEO Company",
    "description": "Lawyer SEO in Cleveland: rank in the local pack, win higher-value cases and outgrow competing Cleveland law firms."
  },
  "/lawyer-seo/connecticut-seo": {
    "title": "Lawyer SEO Connecticut | Law Firm SEO Company",
    "description": "Lawyer SEO in Connecticut: rank in the local pack, win higher-value cases and outgrow competing Connecticut law firms."
  },
  "/lawyer-seo/dallas-seo": {
    "title": "Lawyer SEO Dallas | Law Firm SEO Company",
    "description": "Lawyer SEO in Dallas: rank in the local pack, win higher-value cases and outgrow competing Dallas law firms."
  },
  "/lawyer-seo/delaware-seo": {
    "title": "Lawyer SEO Delaware | Law Firm SEO Company",
    "description": "Lawyer SEO in Delaware: rank in the local pack, win higher-value cases and outgrow competing Delaware law firms."
  },
  "/lawyer-seo/denver-seo": {
    "title": "Lawyer SEO Denver | Law Firm SEO Company",
    "description": "Lawyer SEO in Denver: rank in the local pack, win higher-value cases and outgrow competing Denver law firms."
  },
  "/lawyer-seo/florida-seo": {
    "title": "Lawyer SEO Florida | Law Firm SEO Company",
    "description": "Lawyer SEO in Florida: rank in the local pack, win higher-value cases and outgrow competing Florida law firms."
  },
  "/lawyer-seo/fresno-seo": {
    "title": "Lawyer SEO Fresno | Law Firm SEO Company",
    "description": "Lawyer SEO in Fresno: rank in the local pack, win higher-value cases and outgrow competing Fresno law firms."
  },
  "/lawyer-seo/georgia-seo": {
    "title": "Lawyer SEO Georgia | Law Firm SEO Company",
    "description": "Lawyer SEO in Georgia: rank in the local pack, win higher-value cases and outgrow competing Georgia law firms."
  },
  "/lawyer-seo/houston-seo": {
    "title": "Lawyer SEO Houston | Law Firm SEO Company",
    "description": "Lawyer SEO in Houston: rank in the local pack, win higher-value cases and outgrow competing Houston law firms."
  },
  "/lawyer-seo/illinois-seo": {
    "title": "Lawyer SEO Illinois | Law Firm SEO Company",
    "description": "Lawyer SEO in Illinois: rank in the local pack, win higher-value cases and outgrow competing Illinois law firms."
  },
  "/lawyer-seo/indiana-seo": {
    "title": "Lawyer SEO Indiana | Law Firm SEO Company",
    "description": "Lawyer SEO in Indiana: rank in the local pack, win higher-value cases and outgrow competing Indiana law firms."
  },
  "/lawyer-seo/iowa-seo": {
    "title": "Lawyer SEO Iowa | Law Firm SEO Company",
    "description": "Lawyer SEO in Iowa: rank in the local pack, win higher-value cases and outgrow competing Iowa law firms."
  },
  "/lawyer-seo/jacksonville-seo": {
    "title": "Lawyer SEO Jacksonville | Law Firm SEO Company",
    "description": "Lawyer SEO in Jacksonville: rank in the local pack, win higher-value cases and outgrow competing Jacksonville law firms."
  },
  "/lawyer-seo/kansas-seo": {
    "title": "Lawyer SEO Kansas | Law Firm SEO Company",
    "description": "Lawyer SEO in Kansas: rank in the local pack, win higher-value cases and outgrow competing Kansas law firms."
  },
  "/lawyer-seo/long-island-seo": {
    "title": "Lawyer SEO Long Island | Law Firm SEO Company",
    "description": "Lawyer SEO in Long Island: rank in the local pack, win higher-value cases and outgrow competing Long Island law firms."
  },
  "/lawyer-seo/los-angeles-seo": {
    "title": "Lawyer SEO Los Angeles | Law Firm SEO Company",
    "description": "Lawyer SEO in Los Angeles: rank in the local pack, win higher-value cases and outgrow competing Los Angeles law firms."
  },
  "/lawyer-seo/louisiana-seo": {
    "title": "Lawyer SEO Louisiana | Law Firm SEO Company",
    "description": "Lawyer SEO in Louisiana: rank in the local pack, win higher-value cases and outgrow competing Louisiana law firms."
  },
  "/lawyer-seo/maryland-seo": {
    "title": "Lawyer SEO Maryland | Law Firm SEO Company",
    "description": "Lawyer SEO in Maryland: rank in the local pack, win higher-value cases and outgrow competing Maryland law firms."
  },
  "/lawyer-seo/miami-seo": {
    "title": "Lawyer SEO Miami | Law Firm SEO Company",
    "description": "Lawyer SEO in Miami: rank in the local pack, win higher-value cases and outgrow competing Miami law firms."
  },
  "/lawyer-seo/michigan-seo": {
    "title": "Lawyer SEO Michigan | Law Firm SEO Company",
    "description": "Lawyer SEO in Michigan: rank in the local pack, win higher-value cases and outgrow competing Michigan law firms."
  },
  "/lawyer-seo/minnesota-seo": {
    "title": "Lawyer SEO Minnesota | Law Firm SEO Company",
    "description": "Lawyer SEO in Minnesota: rank in the local pack, win higher-value cases and outgrow competing Minnesota law firms."
  },
  "/lawyer-seo/montana-seo": {
    "title": "Lawyer SEO Montana | Law Firm SEO Company",
    "description": "Lawyer SEO in Montana: rank in the local pack, win higher-value cases and outgrow competing Montana law firms."
  },
  "/lawyer-seo/nevada-seo": {
    "title": "Lawyer SEO Nevada | Law Firm SEO Company",
    "description": "Lawyer SEO in Nevada: rank in the local pack, win higher-value cases and outgrow competing Nevada law firms."
  },
  "/lawyer-seo/new-hampshire-seo": {
    "title": "Lawyer SEO New Hampshire | Law Firm SEO Company",
    "description": "Lawyer SEO in New Hampshire: rank in the local pack, win higher-value cases and outgrow competing New Hampshire law firms."
  },
  "/lawyer-seo/new-mexico-seo": {
    "title": "Lawyer SEO New Mexico | Law Firm SEO Company",
    "description": "Lawyer SEO in New Mexico: rank in the local pack, win higher-value cases and outgrow competing New Mexico law firms."
  },
  "/lawyer-seo/new-york-seo": {
    "title": "Lawyer SEO New York | Law Firm SEO Company",
    "description": "Lawyer SEO in New York: rank in the local pack, win higher-value cases and outgrow competing New York law firms."
  },
  "/lawyer-seo/north-carolina-seo": {
    "title": "Lawyer SEO North Carolina | Law Firm SEO Company",
    "description": "Lawyer SEO in North Carolina: rank in the local pack, win higher-value cases and outgrow competing North Carolina law firms."
  },
  "/lawyer-seo/north-dakota-seo": {
    "title": "Lawyer SEO North Dakota | Law Firm SEO Company",
    "description": "Lawyer SEO in North Dakota: rank in the local pack, win higher-value cases and outgrow competing North Dakota law firms."
  },
  "/lawyer-seo/ohio-seo": {
    "title": "Lawyer SEO Ohio | Law Firm SEO Company",
    "description": "Lawyer SEO in Ohio: rank in the local pack, win higher-value cases and outgrow competing Ohio law firms."
  },
  "/lawyer-seo/orlando-seo": {
    "title": "Lawyer SEO Orlando | Law Firm SEO Company",
    "description": "Lawyer SEO in Orlando: rank in the local pack, win higher-value cases and outgrow competing Orlando law firms."
  },
  "/lawyer-seo/pennsylvania-seo": {
    "title": "Lawyer SEO Pennsylvania | Law Firm SEO Company",
    "description": "Lawyer SEO in Pennsylvania: rank in the local pack, win higher-value cases and outgrow competing Pennsylvania law firms."
  },
  "/lawyer-seo/peoria-seo": {
    "title": "Lawyer SEO Peoria | Law Firm SEO Company",
    "description": "Lawyer SEO in Peoria: rank in the local pack, win higher-value cases and outgrow competing Peoria law firms."
  },
  "/lawyer-seo/philadelphia-seo": {
    "title": "Lawyer SEO Philadelphia | Law Firm SEO Company",
    "description": "Lawyer SEO in Philadelphia: rank in the local pack, win higher-value cases and outgrow competing Philadelphia law firms."
  },
  "/lawyer-seo/phoenix-seo": {
    "title": "Lawyer SEO Phoenix | Law Firm SEO Company",
    "description": "Lawyer SEO in Phoenix: rank in the local pack, win higher-value cases and outgrow competing Phoenix law firms."
  },
  "/lawyer-seo/portland-seo": {
    "title": "Lawyer SEO Portland | Law Firm SEO Company",
    "description": "Lawyer SEO in Portland: rank in the local pack, win higher-value cases and outgrow competing Portland law firms."
  },
  "/lawyer-seo/sacramento-seo": {
    "title": "Lawyer SEO Sacramento | Law Firm SEO Company",
    "description": "Lawyer SEO in Sacramento: rank in the local pack, win higher-value cases and outgrow competing Sacramento law firms."
  },
  "/lawyer-seo/san-antonio-seo": {
    "title": "Lawyer SEO San Antonio | Law Firm SEO Company",
    "description": "Lawyer SEO in San Antonio: rank in the local pack, win higher-value cases and outgrow competing San Antonio law firms."
  },
  "/lawyer-seo/san-bernardino-seo": {
    "title": "Lawyer SEO San Bernardino | Law Firm SEO Company",
    "description": "Lawyer SEO in San Bernardino: rank in the local pack, win higher-value cases and outgrow competing San Bernardino law firms."
  },
  "/lawyer-seo/san-diego-seo": {
    "title": "Lawyer SEO San Diego | Law Firm SEO Company",
    "description": "Lawyer SEO in San Diego: rank in the local pack, win higher-value cases and outgrow competing San Diego law firms."
  },
  "/lawyer-seo/san-francisco-seo": {
    "title": "Lawyer SEO San Francisco | Law Firm SEO Company",
    "description": "Lawyer SEO in San Francisco: rank in the local pack, win higher-value cases and outgrow competing San Francisco law firms."
  },
  "/lawyer-seo/santa-ana-seo": {
    "title": "Lawyer SEO Santa Ana | Law Firm SEO Company",
    "description": "Lawyer SEO in Santa Ana: rank in the local pack, win higher-value cases and outgrow competing Santa Ana law firms."
  },
  "/lawyer-seo/seattle-seo": {
    "title": "Lawyer SEO Seattle | Law Firm SEO Company",
    "description": "Lawyer SEO in Seattle: rank in the local pack, win higher-value cases and outgrow competing Seattle law firms."
  },
  "/lawyer-seo/south-carolina-seo": {
    "title": "Lawyer SEO South Carolina | Law Firm SEO Company",
    "description": "Lawyer SEO in South Carolina: rank in the local pack, win higher-value cases and outgrow competing South Carolina law firms."
  },
  "/lawyer-seo/stockton-seo": {
    "title": "Lawyer SEO Stockton | Law Firm SEO Company",
    "description": "Lawyer SEO in Stockton: rank in the local pack, win higher-value cases and outgrow competing Stockton law firms."
  },
  "/lawyer-seo/tampa-seo": {
    "title": "Lawyer SEO Tampa | Law Firm SEO Company",
    "description": "Lawyer SEO in Tampa: rank in the local pack, win higher-value cases and outgrow competing Tampa law firms."
  },
  "/lawyer-seo/tennessee-seo": {
    "title": "Lawyer SEO Tennessee | Law Firm SEO Company",
    "description": "Lawyer SEO in Tennessee: rank in the local pack, win higher-value cases and outgrow competing Tennessee law firms."
  },
  "/lawyer-seo/texas-seo": {
    "title": "Lawyer SEO Texas | Law Firm SEO Company",
    "description": "Lawyer SEO in Texas: rank in the local pack, win higher-value cases and outgrow competing Texas law firms."
  },
  "/lawyer-seo/tucson-seo": {
    "title": "Lawyer SEO Tucson/AZ | Law Firm SEO Company",
    "description": "Lawyer SEO in Tucson/AZ: rank in the local pack, win higher-value cases and outgrow competing Tucson/AZ law firms."
  },
  "/lawyer-seo/tulsa-seo": {
    "title": "Lawyer SEO Tulsa | Law Firm SEO Company",
    "description": "Lawyer SEO in Tulsa: rank in the local pack, win higher-value cases and outgrow competing Tulsa law firms."
  },
  "/lawyer-seo/ventura-county-seo": {
    "title": "Lawyer SEO Ventura County | Law Firm SEO Company",
    "description": "Lawyer SEO in Ventura County: rank in the local pack, win higher-value cases and outgrow competing Ventura County law firms."
  },
  "/lawyer-seo/vermont-seo": {
    "title": "Lawyer SEO Vermont | Law Firm SEO Company",
    "description": "Lawyer SEO in Vermont: rank in the local pack, win higher-value cases and outgrow competing Vermont law firms."
  },
  "/lawyer-seo/virginia-seo": {
    "title": "Lawyer SEO Virginia | Law Firm SEO Company",
    "description": "Lawyer SEO in Virginia: rank in the local pack, win higher-value cases and outgrow competing Virginia law firms."
  },
  "/lawyer-seo/washington-dc-seo": {
    "title": "Lawyer SEO Washington DC | Law Firm SEO Company",
    "description": "Lawyer SEO in Washington DC: rank in the local pack, win higher-value cases and outgrow competing Washington DC law firms."
  },
  "/lawyer-seo/west-virginia-seo": {
    "title": "Lawyer SEO West Virginia | Law Firm SEO Company",
    "description": "Lawyer SEO in West Virginia: rank in the local pack, win higher-value cases and outgrow competing West Virginia law firms."
  },
  "/lawyer-seo/wisconsin-seo": {
    "title": "Lawyer SEO Wisconsin | Law Firm SEO Company",
    "description": "Lawyer SEO in Wisconsin: rank in the local pack, win higher-value cases and outgrow competing Wisconsin law firms."
  },
  "/lawyer-seo/wyoming-seo": {
    "title": "Lawyer SEO Wyoming | Law Firm SEO Company",
    "description": "Lawyer SEO in Wyoming: rank in the local pack, win higher-value cases and outgrow competing Wyoming law firms."
  }
};
